import { useTranslation } from '../components/blocks';
import { usePageMessaging } from '../components/composites';
import { viewClaimDocument } from '../utils/claimUtils';

export const useViewClaimDocument = () => {
    const pageMessaging = usePageMessaging();
    const { t } = useTranslation('common');

    return async (resellerId: string, uploadId: string, tenantId?: string) => {
        try {
            await viewClaimDocument(resellerId, uploadId, tenantId);
        } catch (error) {
            pageMessaging.showError(t('failedToDownloadDocument-error'));
        }
    };
};
